import(/* webpackMode: "eager" */ "/builds/southchip/official/node_modules/.pnpm/next@14.2.23_@babel+core@7.23.6_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.71.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/builds/southchip/official/node_modules/.pnpm/next@14.2.23_@babel+core@7.23.6_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.71.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/builds/southchip/official/node_modules/.pnpm/nextjs-toploader@1.6.4_next@14.2.23_@babel+core@7.23.6_react-dom@18.2.0_react@18.2.0__r_880f2e9d3466ae9a24ba736f75982f98/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/builds/southchip/official/node_modules/.pnpm/react-hot-toast@2.4.1_csstype@3.1.3_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Footer/Search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalSearch"] */ "/builds/southchip/official/src/components/blocks/Header/GlobalSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HoverItem"] */ "/builds/southchip/official/src/components/blocks/Header/Hover.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Header/MobileNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Header/Nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/builds/southchip/official/src/components/blocks/Header/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pannel"] */ "/builds/southchip/official/src/components/blocks/Header/Pannel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteSelect"] */ "/builds/southchip/official/src/components/blocks/Header/SiteSelect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Header/UserInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/clients/LocaleToStorage.tsx");
;
import(/* webpackMode: "eager" */ "/builds/southchip/official/src/components/DirectusImage/default_cover.png");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/builds/southchip/official/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/ui/client-href.tsx");
;
import(/* webpackMode: "eager" */ "/builds/southchip/official/src/components/ui/router-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Select","SelectTrigger","SelectContent"] */ "/builds/southchip/official/src/components/ui/select.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProviderClient"] */ "/builds/southchip/official/src/messages/client.ts");
